import { reflect } from '@effector/reflect'

import { modalOpener } from '@/shared/ui/modal'

import * as model from './model'
import { LangDialog as View } from './view'

export const LangDialog = {
    View: reflect({
        view: View,
        bind: {
            onLanguageClick: model.languageClicked,
        },
    }),
    model,
}

model.showFx.use(modalOpener(LangDialog.View))
